import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

const vuetify = new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        // primary: "#004141",
        // "primary-dark": "#004141",
        // "primary-light": "#ADE3E3",
        primary: "#4A47B5",
        "primary-dark": "#34317C",
        "primary-light": "#635EF2",
        "light-primary": "#F6F9FF",
        "dark-primary": "#59C09C",
        secondary: "#D95436",
        "secondary-dark": "#75241C",
        "secondary-light": "#F28157",
        danger: "#FF4066",
        "danger-light": "#FF8473",
        success: "#3CE17E",
        "success-light": "#F4FCF5",
        info: "#2DFFF5",
        warning: "#FFB815",
        "warning-light": "#FEF8EE",
        pink: "#EE49FD",
        "pink-light": "#FEF4FF",
        "blue-light": "#EFFAFF",
        white: "#ffffff",
        dark: "#000000",
        "dark-darker": "#0F1322",
        grey: "#858D98",
        "light-bg": "#F1F5FE",
        background: "#FAFCFF",
        slider: "#3fd1c9",
        "text-dark": "#4A47B5",
        "light-blue": "#33BFFF",
        "light-blue-light": "#F6FBFE",
        purple: "#5d40ff",
        "pink-dark": "#FF4066",
        "purple-blue": "#5480FF",
        "dark-purple": "#8628ff",
        "light-green": "#379282",
        yellow: "#ffb83d",
        "dark-blue": "#2C32A9"
      }
    }
  }
});

export default vuetify;
